module.exports = __webpack_public_path__ + "static/media/ico_simulation_nose_tip.27a0aac6.png";